import React from 'react';
import { observer, inject } from 'mobx-react';
import SubMenuIcon from '@material-ui/icons/MoreVert';
import MenuItem from "@material-ui/core/MenuItem";
import { Menu } from '@material-ui/core';
import RenameSheet from './RenameSheet';

const PackLists = ({ store, onClick }) => {
  const { packLists = [], removeSheetFromPack, deleteSheet, listSelectedForMenu } = store;
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [listSelectedForMenu, setListSelectedForMenu] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleSubMenuIconClick(ev, list) {
    ev.stopPropagation();
    ev.preventDefault();
    store.setListSelectedForMenu(list);
    handleClick(ev);
  }

  function handleRemoveFromApplicationPack() {
    handleClose();
    removeSheetFromPack(listSelectedForMenu);
  }

  function handleDeleteSheet() {
    handleClose();
    deleteSheet(listSelectedForMenu);
  }

  function handleRenameSheet(listName) {
    store.handleRenameSheet(listName, listSelectedForMenu)
    handleClose();
  }

  return (
    <div>
      {packLists.map((list, id) => (
        <MenuItem
          className={"menu_list_item " + (store.currentListId == list.id ? " selected" : "")}
          key={id}
          onClick={(ev) => {
            onClick(list)
          }}>
          <span>{list.name}</span>
          {list.name !== "Dashboard" &&
            <SubMenuIcon className={"actions_icon"} onClick={(ev) => handleSubMenuIconClick(ev, list)} />}
        </MenuItem>
      ))
      }
      {
        listSelectedForMenu &&
        <Menu
          anchorEl={anchorEl}
          PaperProps={{
            className: "left_hover_menu_list_options"
          }}
          // keepMounted
          autoFocus={false}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <RenameSheet list={store.listSelectedForMenu} onChange={handleRenameSheet} />
          <MenuItem onClick={handleRemoveFromApplicationPack}> Remove from this Application Pack </MenuItem>
          <MenuItem onClick={handleDeleteSheet}> Delete Sheet </MenuItem>
        </Menu>
      }
    </div>

  );
}
export default observer(PackLists);